import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function formatDate(value) {
  if (!value) return "N/A";

  const rawValue = String(value).trim();

  const date = new Date(
    rawValue.includes("Z") || /[+-]\d{2}:\d{2}$/.test(rawValue)
      ? rawValue
      : rawValue.replace(" ", "T") + "Z"
  );

  if (Number.isNaN(date.getTime())) {
    return "N/A";
  }

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}
export default function UserDashboard() {
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user.id;

  useEffect(() => {
    if (!userId) return;

    axios
      .get(`https://support.g6techcare.com/api/mytickets/${userId}`)
      .then((res) => {
        setTickets(Array.isArray(res.data) ? res.data : []);
      })
      .catch((error) => {
        console.error("Failed to load dashboard tickets:", error);
      });
  }, [userId]);

  const total = tickets.length;

  const open = tickets.filter(
    (t) => String(t.status || "").toLowerCase() !== "closed"
  ).length;

  const closed = tickets.filter(
    (t) => String(t.status || "").toLowerCase() === "closed"
  ).length;

  return (
    <>
      <div className="cards">
        <div className="card" onClick={() => navigate("/my-tickets")}>
          <h3>Total Tickets</h3>
          <p>{total}</p>
        </div>

        <div
          className="card"
          onClick={() => navigate("/my-tickets?status=open")}
        >
          <h3>Open Tickets</h3>
          <p>{open}</p>
        </div>

        <div
          className="card"
          onClick={() => navigate("/my-tickets?status=closed")}
        >
          <h3>Closed Tickets</h3>
          <p>{closed}</p>
        </div>
      </div>

      <div className="table-section">
        <h3>Recent Tickets</h3>

        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Subject</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {tickets.map((t) => (
              <tr key={t.id}>
                <td>#{t.id}</td>
                <td>{t.subject}</td>
                <td>{t.priority}</td>
                <td>{t.status}</td>
                <td>{formatDate(t.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}